import { render, staticRenderFns } from "./FairnessDashboard.vue?vue&type=template&id=79621632&scoped=true"
import script from "./FairnessDashboard.vue?vue&type=script&lang=js"
export * from "./FairnessDashboard.vue?vue&type=script&lang=js"
import style0 from "./FairnessDashboard.vue?vue&type=style&index=0&id=79621632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79621632",
  null
  
)

export default component.exports